<template>
  <v-container>
    <v-row class="mt-3 mb-1 mr-1 d-flex justify-end ga-3">
      <v-btn color="secondary" prepend-icon="mdi-cog" @click="goSettings">
        {{ $t("navBar.settings") }}
      </v-btn>
      <v-btn
        color="primary"
        prepend-icon="mdi-credit-card-outline"
        append-icon="mdi-open-in-new"
        @click="openManageBilling"
      >
        {{ $t("page.account.manageBilling") }}
      </v-btn>
    </v-row>

    <v-row class="mb-4">
      <v-col cols="12" lg="4">
        <account-status-card class="account-page-card" />
      </v-col>
      <v-col cols="12" lg="8">
        <plan-details-card
          class="account-page-card mb-4"
          :plan="userPlan"
          :subscription="userSubscription"
        />
        <plan-options-card :plan="userPlan" :subscription="userSubscription" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script lang="ts" setup>
import { useAccountStore } from "@/account/stores/account";
import AccountStatusCard from "@/account/components/account/AccountStatusCard.vue";
import PlanDetailsCard from "@/account/components/account/PlanDetailsCard.vue";
import PlanOptionsCard from "@/account/components/account/PlanOptionsCard.vue";
import { onMounted, watch, computed } from "vue";
import router from "@/app/router";
import { useSnackBarStore } from "@/shared/stores/snackbar";
import i18n from "@/app/plugins/i18n";
import config from "@/app/configs";

const userPlan = computed(() => {
  return useAccountStore().plan;
});
const userSubscription = computed(() => {
  return useAccountStore().subscription;
});

const goSettings = () => {
  void router.push({ name: "settings" });
};

const openManageBilling = () => {
  if (config?.links.customerPortalLink) {
    window.open(config.links.customerPortalLink, "_blank");
  }
};

const showSuccess = () => {
  const purchaseStatus = router.currentRoute.value.query?.purchase_status;
  if (purchaseStatus === "successful") {
    useSnackBarStore().toastSuccess({
      message: i18n.global.t("page.account.successfulPurchase"),
    });
  }
};

watch(
  () => router.currentRoute.value.query?.purchase_status,
  (newStatus) => {
    if (newStatus === "successful") {
      showSuccess();
    }
  },
  { immediate: true },
);

onMounted(() => {
  const accountStore = useAccountStore();

  accountStore.clearStore();
  void accountStore.fetchPlanInfo();
  showSuccess();
});
</script>

<style scoped>
.account-page-card {
  width: 100%;
}
</style>
